module.exports = __webpack_public_path__ + "img/solved.e909e2c9.svg";